import { useCallback, useMemo } from 'react';
import { useAuthenticatedUserInfo } from '../services/Contexts/AuthenticatedUserInfoContext';
import { useCompanySettings } from './useCompany';
import { resolveOutreachSettings } from '../constants/ewsOutreachSignature';
import {
	appendOutreachSignature,
	formatOutreachEmail,
} from '../utils/outreachEmailBody';

/** Company outreach email options (signature). */
export const useOutreachEmailSettings = (companyIdOverride) => {
	const { companyId: ctxCompanyId } = useAuthenticatedUserInfo();
	const companyId = companyIdOverride || ctxCompanyId;
	const { data: settingsResponse, isLoading } = useCompanySettings(companyId);

	const outreachSettings = useMemo(() => {
		const saved = settingsResponse?.data?.settings?.outreachSettings;
		return resolveOutreachSettings(companyId, saved);
	}, [settingsResponse, companyId]);

	const formatEmail = useCallback(
		(body) => formatOutreachEmail(body, outreachSettings),
		[outreachSettings],
	);

	const withSignature = useCallback(
		(body) => appendOutreachSignature(body, outreachSettings),
		[outreachSettings],
	);

	return { outreachSettings, formatEmail, withSignature, isLoading };
};
